import * as React from 'react';

interface ExternalLinkProps {
  children: React.ReactNode | string,
}

const ExternalLink = ({ children, href, ...rest } :
Omit<Partial<React.AnchorHTMLAttributes<HTMLAnchorElement>>, 'children'> & ExternalLinkProps) => (
  <a
    {...rest}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
  >
    {children}
  </a>
);

export default ExternalLink;
